/* unplugin-vue-components disabled */import script from "./RippleAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./RippleAvatar.vue?vue&type=script&setup=true&lang=js"

import "./RippleAvatar.vue?vue&type=style&index=0&id=aa88c8d8&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa88c8d8"]])

export default __exports__